import UserList from './UserList';
import UserEdit from './UserEdit';
import icon from '../../icon/IcnSettingUser';

export default {
    list : UserList,
    //show : UserShow,
    edit : UserEdit,
    icon : icon 
}